@import '../../theme/global';



:host {
  box-sizing: border-box;
  position: relative;
  @include button-reset;
  @include set-font;

  .snap-dropdown-button {
    align-items: center;
    color: $gray-600;
    cursor: pointer;
    display: flex;

    font-weight: 500;

    &-xs {
      font-size: 12px;
      line-height: 16px;
    }

    &-sm,
    &-base {
      font-size: 14px;
      line-height: 20px;
    }

    &-lg {
      font-size: 16px;
      line-height: 24px;
    }

    &-xl {
      font-size: 24px;
      font-weight: 600;
      line-height: 32px;
    }

    .snap-dropdown-button-icon {
      color: $gray-500;
      margin-right: 4px;
    }

    .snap-dropdown-button-leading-label {
      color: $gray-500;
      font-weight: 500;
      margin-right: 2px;
    }

    .arrow {
      color: $gray-500;
      margin-left: 4px;
    }

    .selected-item-container {
      align-items: center;
      display: flex;
      justify-content: center;
    }

    &:hover,
    &.snap-dropdown-button-open,
    &.snap-dropdown-has-value {
      color: $gray-800;

      .snap-dropdown-button-icon,
      .arrow {
        color: $gray-700;
      }
    }

    &.snap-dropdown-leading-label {
      color: $gray-800;

      .arrow {
        color: $gray-700;
      }
    }

    &-disabled {
      color: $gray-400;
      pointer-events: none;

      &.snap-dropdown-leading-label {
        color: $gray-400;

        .arrow,
        .snap-dropdown-button-leading-label {
          color: $gray-400;
        }
      }

      .snap-dropdown-button-icon,
      .arrow {
        color: $gray-400;
      }

      snap-indicator {
        --indicator-background-color: #{$gray-400};
      }
    }
  }

  .snap-dropdown-button-minimal {
    cursor: pointer;

    &:focus-visible {
      border-radius: 50%;
      box-shadow: 0 0 0 2px #3B82F6;
      outline: none;
    }

    &.snap-dropdown-button-minimal-open {
      .snap-icon-button-minimal .snap-icon{
        background-color: $blue-100 !important;
        border-color: $blue-100 !important;
      }
    }

    .snap-icon-button-minimal {
      &:hover {
        .snap-icon {
          background-color: $blue-200 !important;
          border-color: $blue-200 !important;
        }
      }
    }

    &-disabled {
      pointer-events: none;

      .snap-icon-button-minimal .snap-icon{
        color: $gray-400 !important;
      }
    }
  }

  ul {
    margin: 0;
    padding: 0.5rem 0;
  }

  snap-action-sheet {
    ul.mobile {
      margin-top: 0.5rem;
    }
  }

  .temp-container {
    height: 700px;
    width: 500px;
  }

  .list-menu {
    background-color: $base-light;
    border: 1px $gray-200;
    border-radius: 0.375rem;
    box-shadow: rgba(0, 0, 0, 0.1) 0 4px 6px -1px, rgba(0, 0, 0, 0.06) 0 2px 4px -1px;
    display: block;
    font-size: 1rem;
    line-height: 1.5rem;
    margin-top: 0.25rem;
    min-width: 12.5rem;
    opacity: 1;
    overflow: auto;
    position: absolute;
    right: 0;
    top: 100%;
    transition-duration: 100ms;
    transition-property: background-color, border-color, color, fill, stroke, opacity, box-shadow, transform;
    transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
    z-index: 9999;

    @media (max-width: map-get($breakpoints, 'sm')) {
      font-size: 0.875rem;
      line-height: 1.25rem;
    }

    &.menu-top {
      bottom: 43px;
      top: auto;
    }

    &:focus {
      outline: none;
    }

    &--left {
      left: 0;
      right: initial;
    }

    &-section {
      color: $gray-800;
      font-size: 0.875rem;
      font-weight: 700;
      line-height: 20px;
      padding: 0.5rem 1rem;
    }

    &.with-header {
      min-width: 15.625rem;
      padding-top: 0.5rem;
    }

    &.with-search {
      min-width: 18.75rem;
    }
  }
}

:host(:focus-visible) {
  background: rgba(255, 255, 255, 0.01);
  border-radius: 2px;
  box-shadow: 0 0 0 1px #FFF, 0 0 0 2px #3B82F6;
  outline: none;
}

:host(.no-button) {
  .list-menu {
    margin-top: 1.5rem;
  }
}

snap-indicator {
  --indicator-background-color: #{$gray-600};
  --indicator-text-color: #{$base-light};
  margin-left: 4px;
}

.snap-dropdown-card-search {
  margin: 8px 16px 0;
  position: relative;

  .snap-dropdown-search-field {
    border: 1px solid $gray-300;
    border-radius: 0.625rem;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
    box-sizing: border-box;
    display: block;
    font-size: 0.875rem;
    line-height: 1.25rem;
    padding: 0.5rem 2.5rem 0.5rem 0.813rem;
    width: 100%;

    &:focus {
      border-color: $blue-600;
      box-shadow: 0 0 0 1px $blue-600, 0 1px 2px rgb(0, 0, 0, 0.05);
    }

    &:focus-visible {
      outline: none;
    }
  }

  .snap-dropdown-card-icon-search {
    color: $gray-400;
    display: flex;
    inset: 0 0 0 auto;
    padding-right: 0.813rem;
    pointer-events: none;
    position: absolute;
  }

  .snap-dropdown-card-icon-close {
    bottom: 0;
    color: $gray-400;
    cursor: pointer;
    margin-right: 0.813rem;
    position: absolute;
    right: 0;
    top: 0;
  }
}

// Dropdown
.dropdown-list-modal {
  inset: 0;
  opacity: 0;
  pointer-events: none;
  position: fixed;
  transition: all 0.3s ease 0s;
  z-index: 10000;

  &.open {
    opacity: 1;
    pointer-events: auto;

    @media (min-width: map-get($breakpoints, 'md')) {
      opacity: 0;
      pointer-events: none;
    }

    .dropdown-list-modal-container {
      bottom: 50%;
    }
  }

  &-body {
    margin-top: 1rem;
    max-height: calc(100vh - 64px);
    overflow-y: auto;

    ul.mobile {
      padding: 0.5rem 0;
    }
  }

  &-backdrop {
    background-color: rgba(0, 0, 0, 0.25);
    contain: strict;
    display: block;
    inset: 0;
    position: absolute;
    touch-action: none;
    z-index: 2;
  }

  &-container {
    background-color: rgb(255, 255, 255);
    bottom: -100%;
    height: 100%;
    left: 50%;
    max-height: 100%;
    position: fixed;
    transform: translate(-50%, 50%);
    transition: all 0.3s ease 0s;
    width: 100%;
    z-index: 10;
  }

  &-header {
    align-items: center;
    border-bottom: 1px solid $gray-200;
    color: $gray-800;
    display: flex;
    font-size: 16px;
    font-weight: 600;
    justify-content: space-between;
    line-height: 24px;
    padding: 16px 16px 8px;
  }

  .snap-dropdown-card-search {
    .snap-dropdown-search-field {
      font-size: 1rem;
    }
  }

  .list-menu-section {
    font-size: 1rem;
    line-height: 24px;
  }
}

snap-action-sheet {
  ul.mobile {
    padding-top: 0;
  }

  .snap-dropdown-card-search {
    margin-top: 0;
    padding-top: 16px;

    &::before {
      background: $gray-200;
      content:" ";
      display: block;
      height: 1px;
      left: -16px;
      position: absolute;
      top: 0;
      width: calc(100% + 32px);
    }

    .snap-dropdown-card-icon-search,
    .snap-dropdown-card-icon-close {
      bottom: 0;
      height: 38px;
      top: initial;
    }
  }

  .snap-select-menu-search {
    margin-top: 16px;
  }
}

.no-result-container {
  margin: 16px;
}

.no-result-title {
  color: $gray-800;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  margin: 0 0 8px;
}

.no-result-body {
  color: #64748B;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  margin: 0;
}

:host(:not([search-field])) {
  .dropdown-list-modal-body {
    margin-top: 0;

  }

  snap-action-sheet ul.mobile {
    border-top: 1px solid $gray-200;
  }
}

snap-dropdown-menu-item {
  overflow: hidden;
  padding-right: 1.5rem;
  text-overflow: ellipsis;
  white-space: nowrap;

  &:hover {
    &:not(.active) {
      snap-checkbox-button .input{
        background-color: $base-light;
      }
    }
  }
}

.icon-year-up,
.icon-year-down {
  align-items: center;
  display: flex;
  justify-content: center;

}

.icon-year-up-container {
  align-items: center;
  cursor: pointer;
  display: flex;
  height: 36px;
  justify-content: center;
  width: 100%;

  &:hover {
    background-color: $blue-200;
  }

  &:active {
    background-color: $blue-100;
  }
}

:host(.year-picker) {
  .list-menu {
    min-width: auto;
    padding: 0.5rem 0;
    width: 7.188rem;
  }
}
